import * as React from 'react';
import { FocusStyleManager } from "@blueprintjs/core";
import { ErrorBoundaryDialog } from '#glib/ui/component/ErrorBoundaryDialog';
import { Main } from './components/Main';
import { TermsOfServiceModal } from "./components/TermsOfServiceModal";
import { ErrorDialog } from '#glib/ui/component/ErrorDialog';
import { AppLoadbar } from '#glib/ui/component/AppLoadbar';
import { IApplicationContext } from './context';

// --

FocusStyleManager.onlyShowFocusOnTabs();

/**
 * App
 */
export const App: React.FC<IApplicationContext> = props => {

    return (
        <ErrorBoundaryDialog>
            <AppLoadbar asyncRequests={props.api.asyncRequests} />

            <div className="uk-section">

                <div className="uk-container uk-container-small">
                    <Main {...props} />
                </div>

                <TermsOfServiceModal {...props} />

            </div>

            <ErrorDialog errors={props.api.errors} />
        </ErrorBoundaryDialog>
    )
}
